import { DataTransform } from 'app/models/data-transform';

export abstract class DataTransformAbstractGet implements DataTransform {
  transform(object: any) {
    console.log('transform up', object);
  }

  protected removeUTC(date: string) {
    if (date) {
      return date.replace(/\+\d{4}$/, '');
    }
  }

  protected normalizeMonth(date: string) {
    if (date) {
      return this.removeUTC(date).toString().substring(0, 7);
    }
  }

  protected normalizeDate(date: string) {
    if (date) {
      return this.removeUTC(date).toString().substring(0, 10);
    }
  }
}
